import React from "react";
import Slide from "@material-ui/core/Slide";

export default function TransitionRight(props) {
  return (
    <Slide {...props} direction="right" timeout={{ enter: 750, exit: 750 }} />
  );
}
